import { Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Typography } from "@mui/material"
import { FlatButton } from "src/framework/components/buttons/FlatButton"
import { useObservable } from "src/framework/store/storeUtil"
import { servicoCodeModalIsOpenedStore$ } from "src/store/vendas/projetos/store"
import { setServicoCodeModalStatus } from "src/store/vendas/projetos/actions"
import { ReactNode } from "react"

export const ServicoCodeModalTitle = () => {
  return (
    <>
      <DialogTitle>Código de serviço</DialogTitle>
      <Box paddingBottom={2}>
        <Divider />
      </Box>
    </>
  )
}

export const ServicoCodeModalContent = ({ children }: { children?: ReactNode }) => {
  return (
    <DialogContent style={{ minWidth: "300px" }}>
      <DialogContentText>
      <Typography variant='body2' color='textSecondary' align="left">
        Para a emissão da Nota Fiscal de serviço para a Intelbras, é imprescindível que conste um dos dois códigos de serviço a seguir, conforme a descrição resumida e o CNAE da revenda instaladora:
        <ul>
          <li><strong>14.01</strong>: Inclui serviços de manutenção e conservação de máquinas, veículos, equipamentos e outros itens semelhantes.</li>
          <li><strong>14.06</strong>: Relaciona-se à instalação e montagem de aparelhos, máquinas e equipamentos industriais, entre outros.</li>
        </ul>
      </Typography>

      {children}

      </DialogContentText>
    </DialogContent>
  )
}

function ServicoCodeModal(){
  const isOpened = useObservable(servicoCodeModalIsOpenedStore$)

  return (
    <Dialog
        open={isOpened || false}
        onClose={() => setServicoCodeModalStatus(false)}
      >
        <ServicoCodeModalTitle />

        <ServicoCodeModalContent />

        <DialogActions>
          <FlatButton
            onClick={() => setServicoCodeModalStatus(false)}
            color="primary"
            variant="contained"
            text={'Fechar'}
          ></FlatButton>
        </DialogActions>
      </Dialog>
  )
}

export { ServicoCodeModal }